export type AuthRole = "Program.Deleter" | "Course.Deleter";
